import { useEffect, useRef } from "react";

export default function useWakeLock() {
  const wakeLockRef = useRef(null);

  const requestWakeLock = async () => {
    try {
      if ("wakeLock" in navigator) {
        wakeLockRef.current = await navigator.wakeLock.request("screen");

        wakeLockRef.current.addEventListener("release", () => {
          requestWakeLock();
        });

      } else {
        console.warn("Wake Lock API not supported");
      }
    } catch (err) {
      console.error("WakeLock error:", err);
    }
  };

  useEffect(() => {
    // Request on mount
    requestWakeLock();

    // Re-request if tab becomes visible again
    const handleVisibilityChange = () => {
      if (wakeLockRef.current !== null && document.visibilityState === "visible") {
        requestWakeLock();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      wakeLockRef.current?.release();
      wakeLockRef.current = null;
    };
  }, []);
}
